module.exports = __webpack_public_path__ + "static/media/customersIcon.c23f8fea.svg";